import { render, unmountComponentAtNode } from 'react-dom';
import videojs from 'videojs-mux-kit';
import PlaybackOptionsPopover from '../components/PlaybackOptionsPopover';
import createUsageTracker from './tracker';
import { getHlsTech } from './player';
import { jsx as _jsx } from "react/jsx-runtime";
const VideoJSComponent = videojs.getComponent('Component');
class PlaybackPopover extends VideoJSComponent {
  constructor(player, options) {
    super(player, options);
    this.mount = () => {
      render( /*#__PURE__*/_jsx(PlaybackOptionsPopover, {
        player: this.player(),
        hls: getHlsTech(this.player()),
        tracker: this.tracker
      }), this.el());
    };
    this.el().className = this.buildCSSClass();
    this.tracker = createUsageTracker(); // defer call until plugin setup to ensure start.ts has already called createUsageTracker with initial props

    player.ready(() => {
      this.mount();
    });
    this.on('dispose', () => {
      unmountComponentAtNode(this.el());
    });
  }
  buildCSSClass() {
    return `vjs-playback-options vjs-menu-button vjs-menu-button-popup vjs-control vjs-button ${super.buildCSSClass()}`;
  }
}
VideoJSComponent.registerComponent('PlaybackPopover', PlaybackPopover);